module.exports = __webpack_public_path__ + "static/img/1-07.b72ae13.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/3/1-07.png
// module id = 208
// module chunks = 0